import ForgotPassword from './forgotPassword'
import Login from './login'
import Maintenance from './maintenance'

const routes = [...Login, ...ForgotPassword, ...Maintenance]

export default routes
